import { Injectable } from '@angular/core';
import { logFeature } from '@office-start/telemetry-service';
import { DataSecurityLevel as otelDataSecurityLevel, KnownFeatureNames } from '@office-start/telemetry-types';

import { InstrumentationParam, InstrumentationService, KnownInstrumentationEvents } from '../../shared/instrumentation/instrumentation.service';
import { PinToTaskbarService } from '../../shared/services/pin-to-taskbar.service';
import { CapabilitiesService } from '../../shared/shared-context/capabilities.service';

@Injectable()
export class PwaPinToTaskbarService implements PinToTaskbarService {

    private readonly pinSupported: boolean;
    private readonly taskbarManager: Windows.UI.Shell.TaskbarManager;

    constructor(
        private readonly capabilitiesService: CapabilitiesService,
        private readonly instrumentationService: InstrumentationService
    ) {
        try {
            const apiExist = this.capabilitiesService.capabilities.isPwaInUwp && Windows.Foundation.Metadata.ApiInformation.isTypePresent('Windows.UI.Shell.TaskbarManager');
            this.taskbarManager = apiExist ? Windows.UI.Shell.TaskbarManager.getDefault() : null;
            this.pinSupported = this.taskbarManager && this.taskbarManager.isPinningAllowed;
        } catch {
            const params = {};
            params[InstrumentationParam.State] = 'NotSupported';
            this.instrumentationService.logGenericEvent(KnownInstrumentationEvents.PinToTaskbar, params, [], DataSecurityLevel.Enhanced);
            logFeature({ featureName: KnownFeatureNames.Hwa, eventName: KnownInstrumentationEvents.PinToTaskbar, params }, otelDataSecurityLevel.Enhanced);
        }
    }

    public async isEligibleToPin(): Promise<boolean> {
        return new Promise<boolean>(resolve => {
            if (!this.pinSupported) {
                const params = {};
                params[InstrumentationParam.State] = 'NotSupported';
                this.instrumentationService.logGenericEvent(KnownInstrumentationEvents.PinToTaskbar, params, [], DataSecurityLevel.Enhanced);
                logFeature({ featureName: KnownFeatureNames.Hwa, eventName: KnownInstrumentationEvents.PinToTaskbar, params }, otelDataSecurityLevel.Enhanced);
                resolve(false);
                return;
            }

            this.taskbarManager.isCurrentAppPinnedAsync().then(result => resolve(!result));
        });
    }

    public async pinToTaskbar(): Promise<boolean> {
        return new Promise<boolean>(resolve => {
            if (!this.pinSupported) {
                const params = {};
                params[InstrumentationParam.State] = 'NotSupported';
                this.instrumentationService.logGenericEvent(KnownInstrumentationEvents.PinToTaskbar, params, [], DataSecurityLevel.Enhanced);
                logFeature({ featureName: KnownFeatureNames.Hwa, eventName: KnownInstrumentationEvents.PinToTaskbar, params }, otelDataSecurityLevel.Enhanced);
                resolve(false);
                return;
            }

            this.taskbarManager.requestPinCurrentAppAsync().then(resolve);
        });
    }
}
